import axiosInstance from '@/api/axiosInstance';

export const getWalletBalance = async () => {
  const response = await axiosInstance.get('/users/me/finance/revenues/overview');
  return response.data;
};

export const getFinanceActivities = async ({
  type = null,
  startDate = null,
  endDate = null,
  cursor = null
}) => {
  const params = {};

  if (type && type !== 'ALL') {
    params.type = type;
  }

  if (startDate) {
    params.startDate = startDate;
  }

  if (endDate) {
    params.endDate = endDate;
  }

  if (cursor) {
    params.cursor = cursor;
  }

  const response = await axiosInstance.get('/users/me/finance/activities', { params });
  return response.data;
};

export const getWithdrawalPreview = async (bankAccount) => {
  const response = await axiosInstance.post('/users/me/finance/withdrawal/previews?scope=ALL', {
    bankAccount
  });
  return response.data;
};

export const submitWithdrawal = async (bankAccount, token) => {
  const response = await axiosInstance.post('/users/me/finance/withdrawal?scope=ALL', {
    bankAccount,
    token
  });
  return response.data;
};

export const getWithdrawalDetails = async (id) => {
  const response = await axiosInstance.get(`/users/me/finance/withdrawal/${id}`);
  return response.data;
};